import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { PortalApiService } from '../../portal-api.service';

// Project-wide financial header (accepted value + payment summary + payment
// details), shared by the Quotes / Change Orders / Invoices pages. Self-fetches
// from portal_project_totals given the project id, so the figures are always the
// true project totals — independent of which quotes are shown on the portal.
@Component({
	selector: 'portal-project-totals',
	templateUrl: './project-totals.component.html',
	styleUrls: ['./project-totals.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ProjectTotalsComponent implements OnChanges {

	@Input() projectId!: string;

	summary: any = { total_accepted: 0, currency: null };
	payment: any = { total: 0, paid: 0, to_pay_now: 0, upcoming: 0, currency: null };
	paymentDetails: any = null;

	// The project's own currency, as returned with its totals — never the org's
	// primary currency, which can differ from the one the project is priced in.
	get currency(): string {
		return this.summary?.currency || this.payment?.currency || '';
	}

	constructor(private api: PortalApiService) {}

	ngOnChanges(): void {
		if (!this.projectId) return;
		this.api.project.totals(this.projectId, (t: any) => {
			this.summary = t?.summary || this.summary;
			this.payment = t?.payment || this.payment;
			this.paymentDetails = t?.payment_details || null;
		});
	}
}
